import React, { useState, useEffect } from "react";

const CheckBox = ({ accessor, label, value, callback }) => {
  const [checkboxValue, setValue] = useState(Boolean(value));

  useEffect(() => {
    setValue(Boolean(value));
  }, [value]);

  const handleOnChange = (newValue) => {
    setValue(newValue);
    callback(accessor, newValue);
  };

  return (
    <label htmlFor={`checkbox-${accessor}`}>
      <input
        id={`checkbox-${accessor}`}
        type="checkbox"
        checked={checkboxValue}
        onChange={(e) => handleOnChange(e.target.checked)}
      />
      {label}
    </label>
  );
};

export default CheckBox;
